module.exports = __webpack_public_path__ + "static/media/tf.0d1af327.svg";